
import React, { useContext, useState } from 'react';
import { useHistory } from "react-router-dom";
import DataTable from 'core/ui/data-table';
import FormatDateTime from "core/utils/FormatDateTime";
import SessionContext from 'SessionContext';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert } from 'reactstrap';
import ConfirmSuccess from 'core/ui/confirm-success';

export default function ExternalDestinations() {
  const session = useContext(SessionContext);
  const history = useHistory();
  const [destinationToDelete, setDestinationToDelete] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [tableKey, setTableKey] = useState(false);


  const table_columns = [
      { header: 'End-Point Name', key: 'name'},
      { header: 'Type', key: 'type'},
      { header: 'Status', key: 'enabled', render: (value) => renderStatus(value)},
      { header: 'Created By', key: 'created_by'},
      { header: 'Date Created', key: 'created_date', render: (value) => <FormatDateTime date={value.created_date} />},
    ];
  
    const table_actions = (_data) => (
      <ul className="action-menu">
        <li>
          <button type="button" className="btn btn-link btn-sm" onClick={() => onEditDestination(_data)}>
            <i className="bi bi-pencil"></i> Edit
          </button>
        </li>
        {_data.enabled &&
          <li>
            <button type="button" className="btn btn-link btn-sm" onClick={() => onDisableDestination(_data.id)}>
              <i className="bi bi-dash-circle"></i> Disable
            </button>
          </li>
        } 
        {!_data.enabled &&
          <li>
            <button type="button" className="btn btn-link btn-sm" onClick={() => onEnableDestination(_data.id)}>
              <i className="bi bi-check-circle"></i> Enable
            </button>
          </li>
        }
        <li>
          <button type="button" className="btn btn-link btn-sm" onClick={() => onDeleteDestination(_data)}>
            <i className="bi bi-trash"></i> Delete
          </button>
        </li>
      </ul>
    );

  function onClickBack(ev) {
    ev.stopPropagation();
    history.push("/company-settings");
  }

  function onClickNew(ev) {
    ev.stopPropagation();
    history.push("/external-destination-form");
  }

  function onDeleteDestination(_data) {
    setDestinationToDelete(_data);
    setConfirmDelete(true);
  }

  function onFinalDeleteDestination() {
    session.command(
      `census/delete-destination/${destinationToDelete.id}`,
      {},
      {defaultErrorHandling: false}
    )
      .then(() => {
        toggleDeleteModal();
        setShowSuccess(true);
        setDestinationToDelete(null);
        setTimeout(() => {
          setShowSuccess(false);
          setTableKey(!tableKey);
        }, 2000);
      })
      .catch((err) => {
        console.log("Delete Failed", JSON.stringify(err));
      })
  }

  function onCancelDelete() {
    setDestinationToDelete(null);
    setConfirmDelete(false);
  }

  function onEnableDestination(_id) {
    session.command(`census/enable-destination/${_id}`, {})
      .then(() => {
        setTableKey(!tableKey);
      })
      .catch((err) => {
        console.error("Error enabling destination", err);
      });
  }

  function onDisableDestination(_id) {
    session.command(`census/disable-destination/${_id}`, {})
      .then(() => {
        setTableKey(!tableKey);
      })
      .catch((err) => {
        console.error("Error disabling destination", err);
      });
  }

  function onEditDestination(_data) {
    history.push(`/external-destination-edit-form?am_destination_id=${_data.id}`);
  }

  function renderStatus(_data) {
    if(_data.enabled) {
      return (<span className='enabled'><i className="bi bi-check-circle"></i> Enabled</span>);
    }
    return (<span className='disabled'><i className="bi bi-dash-circle"></i> Disabled</span>);
  }

  function toggleDeleteModal() {
    setConfirmDelete(!confirmDelete);
  }

  return (
    <>
      <div className="page admin-page">
        <div className="list-header sticky-page-header">
          <button className="new-button" onClick={onClickBack}>
            <i className="bi bi-chevron-left"></i> Settings
          </button>
          <h1>External Destinations</h1>
          <i className="spacer" />
          <button className="new-button" onClick={onClickNew}>
            New Destination
          </button>
        </div>
          <div className="invoice-categories">
          <DataTable
            key={tableKey}
            query="census/list"
            cols={table_columns}
            actions={table_actions}
            empty="No External Destinations Found"
          />
          </div>
    </div>
    <Modal centered backdrop
          isOpen={confirmDelete}
        >
          <ModalHeader>
            Delete Destination
          </ModalHeader>
          <ModalBody>
            <Alert color="light" className="d-flex">
              <i className="bi bi-exclamation-octagon"></i>
              <div>
              Selecting <b>delete</b> will permanently remove this destination from AudienceMaker and cannot be undone. Are you sure you want to continue?
              </div>
            </Alert>
            <Alert color="light" className="">
              <p>
                <span className="header-modal-text">Destination Name</span>
                <span className="d-block ms-3">{destinationToDelete?.name || "Unknown"}</span>
              </p>
              <p>
                <span className="header-modal-text">Description</span>
                <span className="d-block ms-3">{destinationToDelete?.description || "No description available"}</span>
              </p>
            </Alert>
          </ModalBody>
          <ModalFooter>
            <Button className="promote" onClick={onCancelDelete}>Cancel</Button>
            <Button onClick={onFinalDeleteDestination}>Delete</Button>
          </ModalFooter>
        </Modal>
      <ConfirmSuccess show={showSuccess} label="Destination deleted successfully." />
      </>
  )
}

